
export const CharacterAction = {
    /**
     * @constant
     * @type {string}
     */
    STAND: 'STAND',
    /**
     * @constant
     * @type {string}
     */
    WALK: 'WALK',
    /**
     * @constant
     * @type {string}
     */
    JUMP: 'JUMP',
    /**
     * @constant
     * @type {string}
     */
    FALL: 'FALL',
    /**
     * @constant
     * @type {string}
     */
    MINE: 'MINE'
};